// import { useContext } from "react";
// import { apivalue } from "./Data/AllData";

import FlavorsSizes from "./Home/FlavorsSizes";
import Footer from "./Home/Footer";
import HeaderHome from "./Home/HeaderHome";
import Navbar from "./Home/Navbar";
import ProductHome from "./Home/ProductHome";

function App() {
  // const data = useContext(apivalue);
  return (
    <div>
      <Navbar/>
      <HeaderHome/>
      <ProductHome/>
      <FlavorsSizes/>
      <Footer/>
    </div>
  );
}

export default App;
